import { useUserStore } from '@Auth/store';
import { UserRole } from '@domain/schemas/user-role';
import { useFeatureFlags } from '@hooks/useFeatureFlags';
import { getUserRole } from '@root/helpers/permissions/utils';

// Matches the roles allowed on the /search page route (get-app-router.tsx)
const ALLOWED_ROLES: string[] = [UserRole.Admin, UserRole.Superadmin, UserRole.User];

/** Gate for mount sites: OpenSearch flag on + user role allowed to search. */
export function useIsCommandPaletteEnabled(): boolean {
  const getFeatureFlag = useFeatureFlags();
  const { user } = useUserStore(({ user }) => ({ user }));

  if (!getFeatureFlag('OpenSearch') || !user) {
    return false;
  }

  const role = getUserRole(user);
  return !!role && ALLOWED_ROLES.includes(role);
}
